import Image from 'next/image'

export default function StrongPassword() {
  return (
    <section className="py-12 lg:py-24 password-generator-strong-password bg-gray-50">
      <div className="max-w-[1280px] xl:px-0 px-5 mx-auto lg:flex-row flex-col flex items-center justify-between gap-5">
        <div className="w-full text-center lg:text-left flex-shrink-0 lg:max-w-[450px] xl:max-w-[520px]">
          <Image
            src="/images/password-generator/StrongPassword.svg"
            alt="Thế nào là mật khẩu mạnh"
            className="object-contain max-w-full w-full"
            width={500}
            height={300}
          />
        </div>
        <div className="flex-1 space-y-6">
          <h2 className="text-display-md lg:text-display-lg font-semibold text-heading mb-5">
            Thế nào là mật khẩu mạnh?
          </h2>
          <p className="text-lg text-heading-desctiption">
            Một mật khẩu mạnh là một mật khẩu đủ dài, ngẫu nhiên, chứa các ký tự phức tạp. Với một
            mật khẩu phức tạp, hacker rất khó có thể đoán ra và xâm nhập vào tài khoản của bạn.
          </p>
          <p className="text-lg font-semibold text-heading">
            <strong>Để đặt một mật khẩu mạnh cần các yếu tố:</strong>
          </p>
          <ul className="pl-4 *:text-lg">
            <li>Có từ 10 kí tự trở lên. Mật khẩu càng dài càng khó để có thể bẻ khóa.</li>
            <li>
              Bao gồm các chữ cái, chữ số, kí tự đặc biệt. Các kí tự này cần được xen kẽ và sắp xếp
              một cách ngẫu nhiên.
            </li>
            <li>Độc nhất, không dùng chung mật khẩu cho nhiều tài khoản internet.</li>
            <li>Không sử dụng tên riêng, các thông tin cá nhân.</li>
            <li>Không sử dụng những con số nổi tiếng như 113, 115, 123456…</li>
            <li>Không đi kèm với các con số mang ý nghĩ như ngày sinh, năm sinh, số điện thoại…</li>
          </ul>
          <p className="text-lg font-semibold text-heading">
            <strong>Các ví dụ về mật khẩu mạnh:</strong>
          </p>
          <ul className="pl-4 *:text-lg">
            <li>1837354839364H: một chuỗi số kết thúc bằng một ký tự</li>
            <li>
              KIkZeXTQ=9NWugO: sự pha trộn của các ký tự có kiểu chữ khác nhau, số, và dấu câu.
            </li>
            <li>MoNOfIn245679: phân biệt chữ thường chữ hoa, chữ số xen kẽ.</li>
            <li>
              ht^3yYhY&Pou&7Uw$Pfq89Hyva: các ký tự phức tạp, xen kẽ số, chữ in hoa, in thường.
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}
